import React from 'react';
import { Button } from 'antd';

import { FullscreenOutlined } from '@ant-design/icons';

const UnitCardHeaderButtons = ({ onFullScreen, isDisableFullScreen }) => (
  <Button
    className="button-full-screen template-info"
    onClick={onFullScreen}
    disabled={isDisableFullScreen}
  >
    <FullscreenOutlined />
  </Button>
);

export default UnitCardHeaderButtons;
